import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { YoutubePlayerBlockConfig } from '@front-platform/content-builder';
import { youtubePlayerBlockResolveConfig } from '@front-platform/content-builder';
import { Component, OnInit, input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
export interface YoutubePlayerBlockRuntimeConfig {}

export type YoutubePlayerBlockConfigInput = Partial<
  Omit<YoutubePlayerBlockConfig, keyof YoutubePlayerBlockRuntimeConfig> &
    YoutubePlayerBlockRuntimeConfig
>;
export type YoutubePlayerBlockResolvedConfig = Omit<
  YoutubePlayerBlockConfig,
  keyof YoutubePlayerBlockRuntimeConfig
> &
  Partial<YoutubePlayerBlockRuntimeConfig>;
export interface YoutubePlayerBlockContract extends ConfigComponentContract<
  YoutubePlayerBlockConfigInput,
  YoutubePlayerBlockResolvedConfig
> {}

@Component({
  selector: 'app-youtube-player-block',
  templateUrl: './youtube-player-block.component.html',
  styleUrls: ['./youtube-player-block.component.scss'],
  standalone: false,
})
export class YoutubePlayerBlockComponent implements OnInit, YoutubePlayerBlockContract {
  readonly config = input<YoutubePlayerBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    YoutubePlayerBlockConfig,
    YoutubePlayerBlockRuntimeConfig
  >(youtubePlayerBlockResolveConfig, () => ({ config: this.config() }));
  get videoId(): string | undefined {
    return this.resolvedConfig()['video_id'] as unknown as string | undefined;
  }
  iframeSrc?: SafeResourceUrl;

  constructor(private readonly sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    const url = 'https://www.youtube.com/embed/' + this.videoId;
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(YoutubePlayerBlockComponent, { 'keyAliases': {} });
